import {
  Button,
  Icons,
  message,
  Progress,
  Tooltip,
  Upload,
  UploadProps,
} from '@pankod/refine-antd'
import React from 'react'

import { getGuruToken } from 'src/helpers/session'

type UploadSupportingDocumentProps = {
  value?: string
  onChange?: (info: any) => void
  onUpload?: (isUploading: boolean) => void
}

const UPLOAD_FILE_SIZE_LIMIT = 16 * 1024 * 1024 // 16 MB

const UPLOAD_FILE_CONSTRAINT = {
  accept: '.pdf',
  type: 'application/pdf',
}

const UploadSupportingDocument = ({
  onChange,
  value,
  onUpload,
}: UploadSupportingDocumentProps) => {
  const [progress, setProgress] = React.useState(0)
  const [isUploading, setIsUploading] = React.useState(false)

  const handleUpload = (uploading: boolean) => {
    if (isUploading !== uploading) setIsUploading(uploading)
    onUpload?.(uploading)
  }

  const handleOnChange: UploadProps['onChange'] = (info) => {
    if (info.file.status === 'uploading') {
      setProgress(info.file.percent || 0)
      handleUpload(true)
      return
    }
    if (info.file.status === 'done') {
      onChange?.(info.file.response?.data?.url)
      setProgress(0)
      handleUpload(false)
    }
    if (info.file.status === 'error') {
      message.error('Gagal mengunggah dokumen')
      handleUpload(false)
    }
  }

  const handleBeforeUpload = (file: File) => {
    if (file.type !== UPLOAD_FILE_CONSTRAINT.type) {
      message.error('Anda hanya dapat mengunggah file PDF')
      return false
    }
    if (file.size > UPLOAD_FILE_SIZE_LIMIT) {
      message.error('Ukuran file tidak boleh lebih dari 16 MB')
      return false
    }
  }

  return (
    <>
      <Upload
        accept={UPLOAD_FILE_CONSTRAINT.accept}
        action={`${process.env.NEXT_PUBLIC_LMS_API_URL}/diklat/uploads`}
        onChange={handleOnChange}
        onRemove={(file) => {
          file.status = undefined
          onChange?.(undefined)
          handleUpload(false)
          return true
        }}
        beforeUpload={handleBeforeUpload}
        headers={{
          Authorization: `Bearer ${getGuruToken()}`,
        }}
        name="file"
        maxCount={1}
        disabled={isUploading}
        itemRender={(_, file, __, { remove }) =>
          (!!value || isUploading) && (
            <div className="flex justify-between items-center gap-4">
              <div className="line-clamp-1 max-w-[100px]">{file.name}</div>
              <Tooltip
                title={isUploading ? '' : 'Hapus dokumen'}
                placement="right"
              >
                <Button
                  type="text"
                  icon={
                    isUploading ? (
                      <Progress
                        className="!-ml-4"
                        percent={Math.round(progress)}
                        steps={5}
                        size="small"
                      />
                    ) : (
                      <Icons.DeleteOutlined />
                    )
                  }
                  danger
                  disabled={isUploading}
                  onClick={remove}
                />
              </Tooltip>
            </div>
          )
        }
      >
        {!value && !isUploading && (
          <Button
            icon={<Icons.UploadOutlined />}
            disabled={isUploading}
            type="default"
            hidden={!!value || isUploading}
          >
            Unggah dokumen
          </Button>
        )}
      </Upload>
    </>
  )
}

export default UploadSupportingDocument
